export default "__VITE_PUBLIC_ASSET__36d8cb2f__"